import { ConversationReadyToLoadStitchName, } from 'owa-mail-store-actions';
import { lazyUpdateLoadedConversation } from 'owa-mail-reading-pane-store';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
export default function subscribeToUpdateLoadedConversationStitch() {
    subscribe(ConversationReadyToLoadStitchName, lazyUpdateLoadedConversation.importAndExecute);
}
//# sourceMappingURL=updateLoadedConversationStitch.js.map